import { cn } from '../lib/cn';

// A mattress's firmness (e.g. "Super Hard") gets missed easily when it's just
// buried in a comma-joined finish string — this renders it as its own
// unmissable tag everywhere an order line's firmness is shown (order detail,
// manufacturing/import/supplier queues, delivery queue).
export function FirmnessBadge({
  value,
  className,
}: {
  value: string | null | undefined;
  className?: string;
}): JSX.Element | null {
  if (!value) return null;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded bg-accent-soft px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-accent',
        className,
      )}
    >
      Firmness: {value}
    </span>
  );
}
